// HEADER: TITLES
export const TITLE_FORM_CAMP = 'Datos de Campamento'
export const TITLE_FORM_CATEGORY = 'Datos de Categoría'
export const TITLE_FORM_CLIENT = 'Datos de Cliente'
export const TITLE_FORM_COMPANY = 'Datos de Compañía'
export const TITLE_FORM_ENTERPRISE = 'Datos de Empresa'
export const TITLE_FORM_OPTION = 'Datos de Opción'
export const TITLE_FORM_PARAMS = 'Datos de Parámetros'
export const TITLE_FORM_PERSON = 'Datos de Persona'
export const TITLE_FORM_PROFILE = 'Datos de Perfil'
export const TITLE_FORM_SITE = 'Datos de Site'
export const TITLE_FORM_USER = 'Datos de Usuario'
export const TITLE_FORM_RECEP_SERVICE = 'Datos de Recepcionador de servicio'
export const TITLE_FORM_CLAIM_USER = 'Datos de Requerimiento'
export const TITLE_FORM_EMAIL_TEMPLATE = 'Datos de Plantilla email'
export const TITLE_FORM_CONFIG_DOCUMENT = 'Datos de Configuración de Documento'
export const TITLE_FORM_CONFIG_FACTURATION = 'Datos de Configuración de Facturación'
// COMPONENTS NAME FORM-TABLE
